import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

interface ResourceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  links: string[];
  path: string;
  index: number;
}

export function ResourceCard({ title, description, icon: Icon, links, path, index }: ResourceCardProps) {
  return (
    <Card className="p-6 space-y-4">
      <div className="flex items-start gap-4">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon className="w-6 h-6 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-semibold mb-2">{title}</h3>
          <p className="text-gray-600 mb-4">{description}</p>
          <ul className="list-disc list-inside mb-4 text-gray-600">
            {links.map((link) => (
              <li key={link}>{link}</li>
            ))}
          </ul>
          <Link to={path}>
            <Button>Explore {title}</Button>
          </Link>
        </div>
      </div>
    </Card>
  );
}